export function getZoomLevel(accuracy: number) {
  if (accuracy < 100) {
    return 20;
  }
  if (accuracy < 500) {
    return 19;
  }
  if (accuracy < 1000) {
    return 17;
  }
  return 16;
}
